import { useQueryClient, useMutation } from 'react-query';
import request from '../../../helpers/request';
import { createInfoAttachmentListKey } from '../queries/useInfoAttachmentList';

const addInfoAttachments = async (infoId, files) => {
  return await Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();

      formData.append('file', file);

      return request.post(
        `/Information/attachment/${infoId}`,
        formData,
        `При загрузке файла ${file.name} произошла ошибка`
      );
    })
  );
};

const useAddInfoAttachments = () => {
  const queryClient = useQueryClient();

  const addAttachmentsMutation = useMutation(
    ({ infoId, files }) => addInfoAttachments(infoId, files),
    {
      onSuccess: (_data, { infoId }) => {
        queryClient.invalidateQueries(createInfoAttachmentListKey(infoId));
      },
    }
  );

  const addAttachmentsMutateAsync = (infoId, files) =>
    addAttachmentsMutation.mutateAsync({ infoId, files });

  return {
    addAttachments: addAttachmentsMutateAsync,
  };
};

export default useAddInfoAttachments;
